(function() {
  'use strict';

  // Configuration
  const BACKEND_ROUTE = '/a/vehicles/vehicleSearchJson';
  const CACHE_KEY_PREFIX = 'vehicle_fitment_cache_';
  const CACHE_DURATION = 30 * 60 * 1000; // 30 minutes in milliseconds

  // Get URL parameters
  function getUrlParams() {
    const params = new URLSearchParams(window.location.search);
    const result = {};
    
    // Get all params as an object
    for (const [key, value] of params.entries()) {
      result[key] = value;
    }
    
    return result;
  }

  // Get collection handle from URL
  function getCollectionHandle() {
    const path = window.location.pathname;
    const match = path.match(/\/collections\/([^\/]+)/);
    return match ? match[1] : null;
  }

  // Render the "No products found for your vehicle" empty state into the product grid.
  // Used both when the vehicle fits NOTHING store-wide AND when it fits products
  // store-wide but none in THIS collection (self-contained: reads the vehicle from
  // the URL, so it can be called from anywhere).
  function showNoProductsForVehicle() {
    const p = /** @type {any} */ (getUrlParams());
    const loadingOverlay = document.getElementById('vehicle-loading-overlay');
    if (loadingOverlay) loadingOverlay.style.display = 'none';

    const productListing = document.getElementById('product-listing');
    if (productListing) {
      productListing.style.display = '';
      productListing.innerHTML = `
        <div class="vehicle-no-results" style="width:100%; padding: 40px 20px; text-align: center;">
          <svg width="48" height="48" viewBox="0 0 38 28" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-bottom:16px; opacity:0.4;">
            <path d="M28.3 20.5L27.9 23.5C27.8 23.4 27.7 23.4 27.5 23.3L26.1 17.4C25.6 14.6 23.4 12.5 20.2 12.6H7.9C5.1 12.6 2.7 13.7 2.2 17.4L0.8 23.3C0.7 23.4 0.6 23.4 0.4 23.5L0.1 20.5C0.1 20.5-4 18.6-5 20.5C-6 22.4-5 23.1-5 23.1L0.8 23.4C-0.2 24.1-0.8 25.2-0.8 26.4V31.6C-0.8 32.9 0.1 34.1 1.4 34.8V38.3C1.4 39.5 2.9 40.5 4.7 40.5C6.5 40.5 8 39.5 8 38.3V35.3H22.1V38.3C22.1 39.5 23.6 40.5 25.4 40.5C27.2 40.5 28.7 39.5 28.7 38.3V35C30.3 34.4 31.4 33.1 31.4 31.6V26.4C31.4 25.2 30.8 24.1 29.8 23.4L35.5 23.1C35.5 23.1 35.7 22.4 35.5 20.5C35.3 18.6 28.3 20.5 28.3 20.5Z" fill="#666"/>
          </svg>
          <p style="font-size: 18px; font-weight: 600; color: #333; margin: 0 0 8px 0;">No products found for your vehicle</p>
          <p style="font-size: 14px; color: #666; margin: 0 0 20px 0;">
            ${decodeURIComponent(p['year'] || '')} ${decodeURIComponent(p['make'] || '')} ${decodeURIComponent(p['model'] || '')} ${decodeURIComponent(p['engine'] || '')}
          </p>
          <a href="${(() => { const u = new URL(window.location.href); u.searchParams.set('show-all', '1'); u.searchParams.delete('make'); u.searchParams.delete('model'); u.searchParams.delete('engine'); u.searchParams.delete('year'); u.searchParams.delete('limit'); u.searchParams.delete('page'); return u.toString(); })()}"
            style="display:inline-block; padding: 10px 24px; background-color: #0072BB; color: #fff; border-radius: 4px; text-decoration: none; font-size: 14px; font-weight: 500;">
            Show all products
          </a>
        </div>
      `;
    }

    const countSection = document.querySelector('.pagination-count-section p');
    if (countSection) countSection.textContent = 'No products match your vehicle';
  }

  // Check if we have all required vehicle params
  function hasVehicleParams(params) {
    // return params.make && params.model && params.engine && params.year;
    return params.make && params.model && params.engine;
  }

  // Generate cache key based on URL params
  function getCacheKey() {
    const params = getUrlParams();
    const collectionHandle = getCollectionHandle();
    
    // Exclude Shopify proxy params but include ALL filter params
    const excludedParams = [
      'shop',
      'logged_in_customer_id', 
      'path_prefix',
      'timestamp',
      'signature',
      'host',
      'hmac',
      'locale',
      'session',
      'id_token',
      'pb',
      
    ];
    
    // Build key data from all non-excluded params + collection handle
   const keyData = {
  collection: collectionHandle
};

for (const [key, value] of Object.entries(params)) {
  if (!excludedParams.includes(key)) {
    // Fully decode to normalize cache keys regardless of encoding in URL
    try {
      keyData[key] = decodeURIComponent(decodeURIComponent(value));
    } catch(e) {
      keyData[key] = value;
    }
  }
}
    
    return CACHE_KEY_PREFIX + JSON.stringify(keyData);
  }

  // Save to cache
  function saveToCache(data) {
    try {
      const cacheKey = getCacheKey();
      const cacheData = {
        timestamp: Date.now(),
        data: data
      };
      localStorage.setItem(cacheKey, JSON.stringify(cacheData));
      console.log('✓ Saved to cache:', cacheKey);
    } catch (e) {
      console.warn('Failed to save to cache:', e);
    }
  }

  // Load from cache
  function loadFromCache() {
    try {
      const cacheKey = getCacheKey();
      const cached = localStorage.getItem(cacheKey);
      
      if (!cached) {
        console.log('No cache found for:', cacheKey);
        return null;
      }

      const cacheData = JSON.parse(cached);
      const age = Date.now() - cacheData.timestamp;

      if (age > CACHE_DURATION) {
        console.log('Cache expired (age:', Math.round(age / 1000), 'seconds)');
        localStorage.removeItem(cacheKey);
        return null;
      }

      console.log('✓ Loaded from cache (age:', Math.round(age / 1000), 'seconds)');
      return cacheData.data;
    } catch (e) {
      console.warn('Failed to load from cache:', e);
      return null;
    }
  }

  // Clear old cache entries
  function clearOldCache() {
    try {
      const keys = Object.keys(localStorage);
      const now = Date.now();
      let clearedCount = 0;
      
      keys.forEach(key => {
        if (key.startsWith(CACHE_KEY_PREFIX)) {
          try {
            const data = JSON.parse(localStorage.getItem(key));
            if (now - data.timestamp > CACHE_DURATION) {
              localStorage.removeItem(key);
              clearedCount++;
            }
          } catch (e) {
            // Invalid cache entry, remove it
            localStorage.removeItem(key);
            clearedCount++;
          }
        }
      });
      
      if (clearedCount > 0) {
        console.log(`Cleared ${clearedCount} old cache entries`);
      }
    } catch (e) {
      console.warn('Failed to clear old cache:', e);
    }
  }
  
  async function loadMatchingProductsViaAjax(collectionHandle, matchingHandles, vehicleParams, fromCache, statusContainer) {
    const productListing = document.getElementById('product-listing');
    const productGrid = productListing?.querySelector('.product-grid, .collection-grid, [class*="grid"]');
    
    if (!productGrid) {
      console.error('❌ Could not find product grid');
      return;
    }

    console.log('📦 Fetching', matchingHandles.length, 'products via AJAX...');
    
    try {
      // Build a query to get ONLY matching products
      // Shopify supports filtering by handle using OR
      const handleQuery = matchingHandles.map(h => `handle:${h}`).join(' OR ');
      
      // Use Shopify's collection products.json endpoint with query
      const ajaxUrl = `/collections/${collectionHandle}/products.json?limit=250`;
      
      console.log('🌐 Fetching from:', ajaxUrl);
      
      const response = await fetch(ajaxUrl);
      
      if (!response.ok) {
        throw new Error(`Failed to fetch products: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('✅ Received', data.products.length, 'products from Shopify');
      
      // Filter to only matching handles
      const matchingProducts = data.products.filter(p => matchingHandles.includes(p.handle));
      
      console.log('🎯 Filtered to', matchingProducts.length, 'matching products');
      
    if (matchingProducts.length === 0) {
  const loadingOverlay = document.getElementById('vehicle-loading-overlay');
  if (loadingOverlay) loadingOverlay.style.display = 'none';

  const productListing = document.getElementById('product-listing');
  if (productListing) {
    productListing.style.display = '';
    productListing.innerHTML = `
      <div class="vehicle-no-results" style="width:100%; padding: 40px 20px; text-align: center;">
        <p style="font-size: 18px; font-weight: 600; color: #333; margin: 0 0 8px 0;">No products found for your vehicle</p>
        <p style="font-size: 14px; color: #666; margin: 0 0 20px 0;">
          ${decodeURIComponent(vehicleParams.year || '')} ${decodeURIComponent(vehicleParams.make || '')} ${decodeURIComponent(vehicleParams.model || '')} ${decodeURIComponent(vehicleParams.engine || '')}
        </p>
        <a href="${(() => { const u = new URL(window.location.href); u.searchParams.set('show-all', '1'); u.searchParams.delete('make'); u.searchParams.delete('model'); u.searchParams.delete('engine'); u.searchParams.delete('year'); u.searchParams.delete('limit'); u.searchParams.delete('page'); return u.toString(); })()}"
           style="display:inline-block; padding: 10px 24px; background-color: #0072BB; color: #fff; border-radius: 4px; text-decoration: none; font-size: 14px; font-weight: 500;">
          Show all products
        </a>
      </div>
    `;
  }
  return;
}
      
      // If we need more products (AJAX only returns first 250), load from other pages
      if (matchingHandles.length > matchingProducts.length) {
        console.log('⚠️ Need to load more products from pagination...');
        await loadRemainingProductsFromPages(collectionHandle, matchingHandles, matchingProducts, productGrid);
      }
      
      // Clear the current grid
      productGrid.innerHTML = '';
      
      // Load each matching product and inject into grid
      for (const product of matchingProducts) {
        await injectProductCard(collectionHandle, product.handle, productGrid);
      }
      
      // Hide loading overlay
      const loadingOverlay = document.getElementById('vehicle-loading-overlay');
      if (loadingOverlay) {
        loadingOverlay.style.display = 'none';
      }
      
      if (productListing) {
        productListing.style.display = '';
      }
      
      // Update status
      const visibleProducts = productGrid.querySelectorAll('[data-product-handle]');
      const visibleFilterData = extractVisibleProductFilterData(Array.from(visibleProducts));
      updateCollectionFilters(visibleFilterData);
      
      const positionCounts = extractFitmentPositions(Array.from(visibleProducts));
      const activeFitmentPosition = sessionStorage.getItem('activeFitmentPosition');
      renderFitmentPositionWidget(positionCounts, activeFitmentPosition);
      
      showFilterStatus(vehicleParams, matchingProducts.length, fromCache);
      
      console.log('✅ Successfully loaded and displayed all matching products!');
      
    } catch (error) {
      console.error('❌ Error loading products via AJAX:', error);
      
      // Fallback to simple filtering
      console.log('⚠️ Falling back to simple filtering...');
      const { visibleCount, visibleProducts } = filterProducts(matchingHandles);
      const visibleFilterData = extractVisibleProductFilterData(visibleProducts);
      updateCollectionFilters(visibleFilterData);
      
      const positionCounts = extractFitmentPositions(visibleProducts);
      const activeFitmentPosition = sessionStorage.getItem('activeFitmentPosition');
      renderFitmentPositionWidget(positionCounts, activeFitmentPosition);
      
      showFilterStatus(vehicleParams, visibleCount, fromCache);
    }
  }

  // Inject a product card by fetching it from a collection page
  async function injectProductCard(collectionHandle, productHandle, productGrid) {
    try {
      // Fetch the collection page to get the product card HTML
      const response = await fetch(`/collections/${collectionHandle}?view=ajax`);
      
      if (!response.ok) {
        console.warn('⚠️ Could not fetch collection page for product:', productHandle);
        return;
      }
      
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Find the specific product card
      const productCard = doc.querySelector(`[data-product-handle="${productHandle}"]`);
      
      if (!productCard) {
        console.warn('⚠️ Product card not found for:', productHandle);
        return;
      }
      
      // Get the wrapper (grid item)
      const productWrapper = productCard.closest('.product-card-outer, .grid__item, [class*="product"]');
      
      if (productWrapper) {
        const clonedWrapper = productWrapper.cloneNode(true);
        productGrid.appendChild(clonedWrapper);
        console.log('✅ Injected product:', productHandle);
      }
      
    } catch (error) {
      console.error('❌ Error injecting product:', productHandle, error);
    }
  }

  // Load remaining products from paginated pages
  async function loadRemainingProductsFromPages(collectionHandle, matchingHandles, alreadyLoaded, productGrid) {
    const loadedHandles = new Set(alreadyLoaded.map(p => p.handle));
    const remainingHandles = matchingHandles.filter(h => !loadedHandles.has(h));
    
    console.log('📄 Loading', remainingHandles.length, 'remaining products from pages...');
    
    let page = 2; // Start from page 2
    const maxPages = 10;
    
    while (remainingHandles.length > 0 && page <= maxPages) {
      try {
        const url = `/collections/${collectionHandle}?page=${page}`;
        const response = await fetch(url);
        
        if (!response.ok) break;
        
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Find products on this page
        const products = doc.querySelectorAll('[data-product-handle]');
        
        if (products.length === 0) break;
        
        products.forEach(product => {
          const handle = product.getAttribute('data-product-handle');
          
          if (remainingHandles.includes(handle)) {
            const wrapper = product.closest('.product-card-outer, .grid__item, [class*="product"]');
            if (wrapper) {
              const cloned = wrapper.cloneNode(true);
              productGrid.appendChild(cloned);
              
              const index = remainingHandles.indexOf(handle);
              remainingHandles.splice(index, 1);
              
              console.log('✅ Loaded from page', page, ':', handle);
            }
          }
        });
        
        page++;
        
      } catch (error) {
        console.error('Error loading page', page, error);
        break;
      }
    }
    
    console.log('✅ Finished loading remaining products');
  }

  
async function fetchMatchingProducts(collectionHandle, vehicleParams) {
  // --- Step 1: Check the prefetch cache written by fitment-widget-main.js / verify-fitment.js ---
  const PREFETCH_KEY = 'vehicle_fitment_all_handles';
  try {
    const raw = localStorage.getItem(PREFETCH_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      const age = Date.now() - (parsed.timestamp || 0);
      const THIRTY_MINUTES = 30 * 60 * 1000;

      if (age < THIRTY_MINUTES && Array.isArray(parsed.handles)) {
        console.log('🔵 [SOURCE: prefetch_cache] all_handles count:', parsed.handles.length);
  console.log('🔵 [SOURCE: prefetch_cache] handles:', parsed.handles);
        
        console.log(
          '✓ Using prefetched vehicle_fitment_all_handles — skipping vehicleSearchJson call.',
          'Total handles:', parsed.handles.length
        );
        return {
          success: true,
          product_handles: parsed.handles,      // ← use ALL handles, not DOM-intersected
          all_product_handles: parsed.handles,
          total_matching: parsed.handles.length,
          _source: 'prefetch_cache'
        };
      } else if (age >= THIRTY_MINUTES) {
        console.log('Prefetch cache expired, falling back to API.');
        localStorage.removeItem(PREFETCH_KEY);
      }
    }
  } catch (e) {
    console.warn('Failed to read prefetch cache:', e);
  }

  // --- Step 2: Check the per-collection vehicleSearchJson cache ---
  const cachedResult = loadFromCache();
  if (cachedResult) {
     console.log('🟡 [SOURCE: collection_cache] product_handles count:', (cachedResult.product_handles || []).length);
  console.log('🟡 [SOURCE: collection_cache] product_handles:', cachedResult.product_handles);
  console.log('🟡 [SOURCE: collection_cache] all_product_handles count:', (cachedResult.all_product_handles || []).length);
    
  console.log('Using cached vehicle fitment data (collection cache)');
  // Backfill vehicle_fitment_all_handles if missing
  try {
    const existing = localStorage.getItem('vehicle_fitment_all_handles');
    if (!existing && Array.isArray(cachedResult.all_product_handles)) {
      localStorage.setItem('vehicle_fitment_all_handles', JSON.stringify({
      handles: cachedResult.all_product_handles.length === 0 ? ['no-handles'] : cachedResult.all_product_handles,
        timestamp: Date.now()
      }));
      console.log('✓ Backfilled vehicle_fitment_all_handles from collection cache:', cachedResult.all_product_handles.length, 'handles');
    }
  } catch(e) {
    console.warn('Failed to backfill vehicle_fitment_all_handles:', e);
  }
  return cachedResult;
}

  // --- Step 3: No cache at all — fetch from API ---
  console.log('Fetching fresh vehicle fitment data from API');

  try {
    const queryParams = new URLSearchParams({
      make: vehicleParams.make,
      model: vehicleParams.model,
      engine: vehicleParams.engine,
      year: vehicleParams.year,
      collection: collectionHandle
    });

    const url = `${BACKEND_ROUTE}?${queryParams.toString()}`;
    console.log('Fetching matching products:', url);

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('Backend response:', data);

   if (data && data.success) {
  saveToCache(data);
  // Also populate vehicle_fitment_all_handles so other pages (PDP, other collections) can use it
  try {
    if (Array.isArray(data.all_product_handles)) {
      localStorage.setItem('vehicle_fitment_all_handles', JSON.stringify({
        handles: data.all_product_handles.length === 0 ? ['no-handles'] : data.all_product_handles,
        timestamp: Date.now()
      }));
      console.log('✓ Saved vehicle_fitment_all_handles from fresh API response:', data.all_product_handles.length, 'handles');
    }
  } catch(e) {
    console.warn('Failed to save vehicle_fitment_all_handles:', e);
  }
}

    return data;
  } catch (error) {
    console.error('Error fetching matching products:', error);
    return null;
  }
}

  // Hide all products initially while loading
  function hideAllProducts() {
    const productCards = document.querySelectorAll('[data-product-handle]');
    console.log('Hiding all products while loading...');
    
    productCards.forEach(card => {
      const gridWrapper = card.closest('.product-card-outer');
      if (gridWrapper) {
        gridWrapper.style.display = 'none';
      }
    });
  }

  // Show all products (used if filtering fails)
  function showAllProducts() {
    const productCards = document.querySelectorAll('[data-product-handle]');
    console.log('Showing all products...');
    
    productCards.forEach(card => {
      const gridWrapper = card.closest('.product-card-outer');
      if (gridWrapper) {
        gridWrapper.style.display = '';
      }
    });
  }

  // Filter products on the page
function filterProducts(matchingHandles) {
  const productListing = document.getElementById('product-listing');
  const loadingOverlay = document.getElementById('vehicle-loading-overlay');
  const productCards = document.querySelectorAll('[data-product-handle]');
  let hiddenCount = 0;
  let visibleCount = 0;
  const visibleProducts = []; // NEW: Collect visible products

  console.log('Total product cards found:', productCards.length);
  console.log('Matching handles:', matchingHandles);

  productCards.forEach(card => {
    const handle = card.getAttribute('data-product-handle');
    
    // Find the outer grid wrapper (.product-card-outer)
    const gridWrapper = card.closest('.product-card-outer');
    
    if (!gridWrapper) {
      console.warn('No grid wrapper found for product:', handle);
      return;
    }
    
    if (matchingHandles.includes(handle)) {
      gridWrapper.style.display = '';
      visibleProducts.push(card); // NEW: Collect visible cards
      visibleCount++;
      console.log('✓ Showing product:', handle);
    } else {
      gridWrapper.style.display = 'none';
      hiddenCount++;
      console.log('✗ Hiding product:', handle);
    }
  });

  // Hide loading overlay and show product grid
  if (loadingOverlay) {
    loadingOverlay.style.display = 'none';
  }
  
  if (productListing) {
    productListing.style.display = '';
  }

  console.log(`Filtered: ${visibleCount} visible, ${hiddenCount} hidden`);
  console.log('⚪ [filterProducts] visibleCount being returned (this becomes the count text):', visibleCount);
  return { visibleCount, hiddenCount, visibleProducts }; // NEW: Return visibleProducts
}
function extractVisibleProductFilterData(visibleProducts) {
  console.log('📊 Extracting filter data from', visibleProducts.length, 'visible products');
  
  const filterCounts = new Map(); // Map<filterValue, count>
  
  visibleProducts.forEach(card => {
    // Extract vendor/brand
    const vendor = card.getAttribute('data-vendor');
    if (vendor && vendor !== 'null' && vendor.trim()) {
      const vendorLower = vendor.trim().toLowerCase();
      filterCounts.set(vendorLower, (filterCounts.get(vendorLower) || 0) + 1);
    }
    
    // Extract all metafield values
    const metafieldAttributes = [
      'data-filter-fitting',
      'data-custom-bulb-fitting-type',
      'data-custom-bulb-technology',
      'data-custom-bulb-pack-type',
      'data-custom-bulb-voltage',
      'data-custom-bulb-wattage',
      'data-custom-bulb-temperature',
      'data-custom-bulbs-type',
      'data-custom-bulb-filament-type',
      'data-custom-e-marked',
      'data-filter-brake-fluid-type',
      'data-filter-oil-type',
      'data-filter-size'
    ];
    
    metafieldAttributes.forEach(attr => {
      const value = card.getAttribute(attr);
      if (value && value !== 'null' && value.trim()) {
        const valueLower = value.trim().toLowerCase();
        filterCounts.set(valueLower, (filterCounts.get(valueLower) || 0) + 1);
      }
    });
  });
  
  console.log('Filter value counts:', Object.fromEntries(filterCounts));
  
  return {
    filterCounts: filterCounts,
    allFilterValues: Array.from(filterCounts.keys())
  };
}
function extractFitmentPositions(visibleProducts) {
  console.log('🎯 Extracting fitment positions from', visibleProducts.length, 'products');
  
  const positionCounts = new Map(); // Map<position, count>
  
  visibleProducts.forEach(card => {
    // Get the fitmentPosition metafield value
    const positions = card.getAttribute('data-filter-fitting');
    
    if (positions && positions !== 'null' && positions.trim()) {
      // Parse if it's a JSON array, otherwise treat as single value
      let positionArray = [];
      
      try {
        if (positions.startsWith('[')) {
          positionArray = JSON.parse(positions);
        } else {
          positionArray = [positions];
        }
      } catch (e) {
        positionArray = [positions];
      }
      
      // Count each position
      positionArray.forEach(position => {
        const trimmedPosition = position.trim();
        if (trimmedPosition) {
          positionCounts.set(trimmedPosition, (positionCounts.get(trimmedPosition) || 0) + 1);
        }
      });
    }
  });
  
  console.log('Fitment positions found:', Object.fromEntries(positionCounts));
  
  return positionCounts;
}

//SHOP BY FITMENT TRY - DONOT CHANGE
function broadcastFitmentPositions(positionCounts) {
  const positions = Array.from(positionCounts.keys());
  // Store on window so late-registering listeners can read it immediately
  window.__vehicleFitmentPositions = positions;
  document.dispatchEvent(new CustomEvent('vehicleFitmentPositionsReady', {
    detail: { positions: positions }
  }));
  console.log('📡 Broadcasted vehicle fitment positions:', positions);
}
function renderFitmentPositionWidget(positionCounts, currentFilter = null) {
  console.log('🎨 Rendering fitment position widget');
  
  const widget = document.getElementById('fitment-position-widget');
  const buttonsContainer = document.getElementById('fitment-position-buttons');
  const activeIndicator = document.getElementById('active-fitment-position');
  const activePositionName = document.getElementById('active-position-name');
  
  if (!widget || !buttonsContainer) {
    console.warn('⚠️ Fitment position widget elements not found');
    return;
  }
  
  // If no positions, hide the widget
  if (positionCounts.size === 0) {
    widget.style.display = 'none';
    return;
  }
  
  // Clear existing buttons
  buttonsContainer.innerHTML = '';
  
  // Sort positions alphabetically
  const sortedPositions = Array.from(positionCounts.entries()).sort((a, b) => a[0].localeCompare(b[0]));
  
  // Create button for each position
  sortedPositions.forEach(([position, count]) => {
    const button = document.createElement('button');
    button.className = 'fitment-position-button';
    if (currentFilter === position) {
      button.classList.add('active');
    }
    
    button.innerHTML = `
      <span class="fitment-position-icon"></span>
      <span>${position}</span>
      <span class="count">(${count})</span>
    `;
    
    button.addEventListener('click', () => {
      handleFitmentPositionClick(position);
    });
    
    buttonsContainer.appendChild(button);
  });
  
  // Show/hide active filter indicator
  if (currentFilter) {
    activeIndicator.style.display = '';
    activePositionName.textContent = currentFilter;
  } else {
    activeIndicator.style.display = 'none';
  }
  
  // Show the widget
  widget.style.display = '';
  
  console.log(`✅ Rendered ${sortedPositions.length} fitment position buttons`);
}
function handleFitmentPositionClick(position) {
  console.log('🔍 Filtering by fitment position:', position);
  
  // Store in session storage
  sessionStorage.setItem('activeFitmentPosition', position);
  
  // Filter products by this position
  const productCards = document.querySelectorAll('[data-product-handle]');
  let visibleCount = 0;
  let hiddenCount = 0;
  const visibleProducts = [];
  
  productCards.forEach(card => {
    const positions = card.getAttribute('data-filter-fitting');
    const gridWrapper = card.closest('.product-card-outer');
    
    if (!gridWrapper) return;
    
    let hasPosition = false;
    
    if (positions && positions !== 'null') {
      try {
        let positionArray = [];
        if (positions.startsWith('[')) {
          positionArray = JSON.parse(positions);
        } else {
          positionArray = [positions];
        }
        
        hasPosition = positionArray.some(p => p.trim() === position);
      } catch (e) {
        hasPosition = positions.trim() === position;
      }
    }
    
    if (hasPosition) {
      gridWrapper.style.display = '';
      visibleProducts.push(card);
      visibleCount++;
    } else {
      gridWrapper.style.display = 'none';
      hiddenCount++;
    }
  });
  
  console.log(`Filtered: ${visibleCount} visible, ${hiddenCount} hidden`);
  
  // Re-extract positions from visible products and re-render
  const newPositionCounts = extractFitmentPositions(visibleProducts);
  renderFitmentPositionWidget(newPositionCounts, position);
  
  // Update collection filters
  const visibleFilterData = extractVisibleProductFilterData(visibleProducts);
  updateCollectionFilters(visibleFilterData);
}
// Clear the fitment position filter
function clearFitmentPositionFilter() {
  console.log('🧹 Clearing fitment position filter');
  
  // Remove from session storage
  sessionStorage.removeItem('activeFitmentPosition');
  
  // Show all products again (or respect vehicle filter if active)
  const vehicleFilter = sessionStorage.getItem('vehicleFilter');
  
  if (vehicleFilter) {
    // If vehicle filter is active, re-apply it
    const { matchingHandles } = JSON.parse(vehicleFilter);
    const { visibleProducts } = filterProducts(matchingHandles);
    const positionCounts = extractFitmentPositions(visibleProducts);
    renderFitmentPositionWidget(positionCounts, null);
  } else {
    // Show all products
    const productCards = document.querySelectorAll('[data-product-handle]');
    const visibleProducts = [];
    
    productCards.forEach(card => {
      const gridWrapper = card.closest('.product-card-outer');
      if (gridWrapper) {
        gridWrapper.style.display = '';
        visibleProducts.push(card);
      }
    });
    
    const positionCounts = extractFitmentPositions(visibleProducts);
    renderFitmentPositionWidget(positionCounts, null);
  }
}
function updateCollectionFilters(visibleFilterData) {
  console.log('🔄 Updating collection filters based on visible products');
  
  const filterSidebar = document.querySelector('.filter-drawer-body');
  
  if (!filterSidebar) {
    console.log('⚠️ No filter sidebar found');
    return;
  }
  
  console.log('Found filter sidebar');
  
  // Find all filter wrappers
  const filterWrappers = filterSidebar.querySelectorAll('.collection-filter-wrapper, details.collection-filter-wrapper');
  
  console.log(`  Found ${filterWrappers.length} filter groups`);
  
  filterWrappers.forEach(wrapper => {
    const filterTitle = wrapper.querySelector('.collection-filter-title, summary');
    const filterLabel = filterTitle ? (filterTitle.getAttribute('data-filter-label') || filterTitle.textContent.trim()) : 'Unknown';
    
    console.log(`  📁 Processing filter: ${filterLabel}`);
    
    // Find all filter items
    const filterItems = wrapper.querySelectorAll('.collection-filter-value, li.collection-filter-value');
    
    let visibleItemCount = 0;
    let hiddenItemCount = 0;
    
    filterItems.forEach(item => {
      const label = item.querySelector('label');
      if (!label) return;
      
      // Get the filter value text and clean it
      let filterValueText = label.textContent.trim();
      // Remove the count in parentheses like "(5)"
      filterValueText = filterValueText.replace(/\(\d+\)$/, '').trim();
      const filterValueLower = filterValueText.toLowerCase();
      
      if (!filterValueText) return;
      
      // Check if this filter value exists in visible products
      let matchedCount = 0;
      let isRelevant = false;
      
      // Try exact match first
      if (visibleFilterData.filterCounts.has(filterValueLower)) {
        matchedCount = visibleFilterData.filterCounts.get(filterValueLower);
        isRelevant = true;
      } else {
        // Try fuzzy match (partial match)
        for (const [value, count] of visibleFilterData.filterCounts.entries()) {
          if (value === filterValueLower || 
              filterValueLower.includes(value) || 
              value.includes(filterValueLower)) {
            matchedCount = count;
            isRelevant = true;
            break;
          }
        }
      }
      
      if (isRelevant && matchedCount > 0) {
        item.style.display = '';
        visibleItemCount++;
        
        // Update the count display
        const countSpan = item.querySelector('.count-numb, .text-small');
        if (countSpan) {
          countSpan.textContent = `(${matchedCount})`;
        }
      } else {
        item.style.display = 'none';
        hiddenItemCount++;
      }
    });
    
    console.log(`    ✓ ${filterLabel}: ${visibleItemCount} shown, ${hiddenItemCount} hidden`);
    
    // Hide entire filter group if no items are visible
    if (visibleItemCount === 0 && filterItems.length > 0) {
      wrapper.style.display = 'none';
      console.log(`    ⚠️ Hiding entire ${filterLabel} filter (no matching values)`);
    } else {
      wrapper.style.display = '';
    }
  });
  
  console.log('✅ Collection filters updated with counts');
}
  // Show vehicle filter status
function showFilterStatus(vehicleParams, productCount, fromCache) {
  const statusContainer = document.getElementById('vehicle-fitment-status');
  const vehicleInfoText = document.getElementById('vehicle-info-text');
  const vehicleProductCount = document.getElementById('vehicle-product-count');

  if (statusContainer && vehicleInfoText && vehicleProductCount) {
    const make = decodeURIComponent(vehicleParams.make || '');
    const model = decodeURIComponent(vehicleParams.model || '');
    const engine = decodeURIComponent(vehicleParams.engine || '');
    const year = vehicleParams.year;
    const vehicleInfo = `${year} ${make} ${model} ${engine}`;
    vehicleInfoText.textContent = `Showing products compatible with: ${vehicleInfo}`;
    vehicleProductCount.textContent = `${productCount} compatible product${productCount !== 1 ? 's' : ''} found.`;
    statusContainer.style.display = 'block';
  }

  updateProductCountText(productCount);
}


function updateProductCountText(visibleCount) {
  if (visibleCount === undefined) return;

  // Read the true collection total from the Liquid-rendered data attribute
  const paginationEl = document.querySelector('[data-pagination-count]');
  const collectionTotal = paginationEl
    ? (parseInt(paginationEl.getAttribute('data-collection-total'), 10) || visibleCount)
    : visibleCount;

  const text = `Showing ${visibleCount} of ${collectionTotal} products`;

  if (window.__vehicleCountObserver) {
    window.__vehicleCountObserver.disconnect();
    window.__vehicleCountObserver = null;
  }

  function applyCount() {
    const el = document.querySelector('[data-pagination-count]');
    if (el) {
      el.textContent = text;
      el.setAttribute('data-vehicle-filter-count', visibleCount);
      return true;
    }
    return false;
  }

  applyCount();

  const observer = new MutationObserver(() => {
    const el = document.querySelector('[data-pagination-count]');
    if (el && !el.getAttribute('data-vehicle-filter-count')) {
      el.textContent = text;
      el.setAttribute('data-vehicle-filter-count', visibleCount);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
  window.__vehicleCountObserver = observer;

  setTimeout(() => {
    observer.disconnect();
    window.__vehicleCountObserver = null;
  }, 8000);
}
  // Clear filter and reload page
  function clearFilter() {
    const url = new URL(window.location.href);
    url.searchParams.delete('make');
    url.searchParams.delete('model');
    url.searchParams.delete('engine');
    url.searchParams.delete('year');
    window.location.href = url.toString();
  }
function injectVehicleParamsIntoFiltersForm() {
  const form = document.getElementById('FiltersForm');
  if (!form) return;

const vehicleParamKeys = ['make', 'model', 'engine', 'year', 'limit','show-all'];
  const urlParams = new URLSearchParams(window.location.search);

  function doInject() {
    vehicleParamKeys.forEach(key => {
      const val = urlParams.get(key);
      if (!val) return;
      // Remove any existing hidden input for this key to avoid duplicates
      const existing = form.querySelector(`input[type="hidden"][name="${key}"]`);
      if (existing) existing.remove();
      const hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = key;
      hidden.value = val;
      form.appendChild(hidden);
    });
  }

  // Inject immediately
  doInject();

  // Also re-inject on submit in case the form is re-rendered
  form.addEventListener('submit', doInject);
}

  function interceptPaginationLinks() {
    const currentParams = new URLSearchParams(window.location.search);
    const isShowAll = currentParams.get('show-all') === '1';

    // If show-all is active, pagination should NOT carry vehicle params
    if (isShowAll) return;

    const vehicleKeys = ['make', 'model', 'engine', 'year', 'limit'];
    const hasVehicle = vehicleKeys.some(k => currentParams.get(k));
    if (!hasVehicle) return;

    document.querySelectorAll('a[href*="page="]').forEach(link => {
      // Skip links that already have vehicle params
      const existingHref = link.getAttribute('href');
      if (!existingHref || existingHref.includes('make=')) return;

      link.addEventListener('click', function(e) {
        e.preventDefault();
        const targetUrl = new URL(this.href, window.location.origin);
        vehicleKeys.forEach(k => {
          const val = currentParams.get(k);
          if (val) targetUrl.searchParams.set(k, val);
        });
        window.location.href = targetUrl.toString();
      });
    });
  }

  // Main initialization
  async function init() {
    console.log('Vehicle collection filter script loaded');
    
    // Clear old cache entries on load
    clearOldCache();
    
    // Only run on collection pages
     if (!window.location.pathname.includes('/collections/')) {
      console.log('Not a collection page — applying fitment labels from cache only');
      // Still apply fitment labels using the global all-handles cache
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => applyFitmentLabels(null));
      } else {
        applyFitmentLabels(null);
      }
      return;
    }


  
   const params = getUrlParams();
  if (params['show-all'] === '1') {
  console.log('show-all=1 in URL — showing all products, skipping vehicle filter');
  sessionStorage.setItem('vehicle_show_all', '1');
  showAllProducts();
  applyFitmentLabels(null);
  return;
}
    const vehicleParams = {
      make: params.make ? decodeURIComponent(params.make) : undefined,
      model: params.model ? decodeURIComponent(params.model) : undefined,
      engine: params.engine ? decodeURIComponent(params.engine) : undefined,
      year: params.year ? decodeURIComponent(params.year) : undefined
    };
    
    // Check if we have vehicle params
// If no vehicle params in URL, check localStorage and do ONE redirect with all 5 params
   if (!hasVehicleParams(vehicleParams)) {
      // If the user explicitly clicked "Show all products", don't redirect back
      if (sessionStorage.getItem('vehicle_show_all') === '1') {
        console.log('show-all active (sessionStorage) — skipping vehicle redirect');
        showAllProducts();
        applyFitmentLabels(null);
        return;
      }
      try {
        const savedRaw = localStorage.getItem('vehicle_fitment_active');
        if (savedRaw) {
          const v = JSON.parse(savedRaw);
          if (v.make && v.model && v.engine) {
            console.log('🚗 No vehicle in URL — found saved vehicle, redirecting with all params');
            const url = new URL(window.location.href);
            url.searchParams.set('make', v.make);
            url.searchParams.set('model', v.model);
            url.searchParams.set('engine', v.engine);
            if (v.year) url.searchParams.set('year', String(v.year));
            url.searchParams.set('limit', '250');
            window.location.replace(url.toString());
            return;
          }
        }
      } catch(e) {
        console.warn('Failed to read saved vehicle from localStorage:', e);
      }
      applyFitmentLabels(null);
      return;
    }

    // Vehicle IS in URL — if limit=250 missing, add it and redirect once (keeps all other params)
    if (!params.limit) {
      const url = new URL(window.location.href);
      url.searchParams.set('limit', '250');
      window.location.replace(url.toString());
      return;
    }
   //USE this when it rerenders for limit 250 
//    const currentLimit = new URLSearchParams(window.location.search).get('limit');
// if (currentLimit !== '250') {
//   const url = new URL(window.location.href);
//   url.searchParams.set('limit', '250');
//   window.location.replace(url.toString()); // replace so back button still works cleanly
//   return;
// }
    const collectionHandle = getCollectionHandle();
    
    if (!collectionHandle) {
      console.error('Could not extract collection handle from URL');
      return;
    }

    console.log('Vehicle params found:', vehicleParams);
    console.log('Collection handle:', collectionHandle);


    sessionStorage.removeItem('vehicle_show_all');


    // Hide all products immediately while loading
    hideAllProducts();

    // Show loading state
    const statusContainer = document.getElementById('vehicle-fitment-status');
    if (statusContainer) {
      statusContainer.style.display = 'block';
      const infoText = document.getElementById('vehicle-info-text');
      const countText = document.getElementById('vehicle-product-count');
      if (infoText) infoText.textContent = 'Loading compatible products...';
      if (countText) countText.textContent = '';
    }

    // Fetch matching products (will use cache if available)
   const result = await fetchMatchingProducts(collectionHandle, vehicleParams);
const matchingHandles = result.product_handles || [];
    const totalMatching = result.total_matching || matchingHandles.length;
    const fromCache = loadFromCache() !== null;
console.log('⚪ [INIT] result._source:', result._source || 'fresh_api');
console.log('⚪ [INIT] matchingHandles going into filter — count:', matchingHandles.length);
console.log('⚪ [INIT] matchingHandles:', matchingHandles);
// Save ALL vehicle-matching handles globally so any page can resolve fitment labels
if (Array.isArray(result.all_product_handles)) {
  try {
    localStorage.setItem('vehicle_fitment_all_handles', JSON.stringify({
      handles: result.all_product_handles.length === 0 ? ['no-handles'] : result.all_product_handles,
      timestamp: Date.now()
    }));
    console.log('✓ Saved vehicle_fitment_all_handles with', result.all_product_handles.length, 'handles');
  } catch(e) {
    console.warn('Failed to save vehicle_fitment_all_handles:', e);
  }
}
    console.log('Received matching handles from API:', matchingHandles);
    console.log('Total matching from API:', totalMatching);

    if (!result || !result.success) {
      console.error('Failed to fetch matching products', result);
      if (statusContainer) {
        statusContainer.style.display = 'none';
      }
      showAllProducts();
      alert('Error loading vehicle fitment data. Please try again.');
      return;
    }

    const clearButton = document.getElementById('clear-vehicle-filter');
    if (clearButton) {
      clearButton.addEventListener('click', clearFilter);
    }

        if (matchingHandles.length === 0) {
      applyFitmentLabels(matchingHandles);
      // Vehicle fits nothing store-wide → the shared no-products empty state.
      showNoProductsForVehicle();
      return;
    }

    // Check if all matching products are loaded on current page
    const currentPageHandles = [];
    document.querySelectorAll('[data-product-handle]').forEach(el => {
      currentPageHandles.push(el.getAttribute('data-product-handle'));
    });
console.log('⚪ [INIT] DOM cards on this page:', currentPageHandles.length, currentPageHandles);
const inCollectionHandles = matchingHandles.filter(h => currentPageHandles.includes(h));
console.log('⚪ [INIT] matchingHandles that are IN this collection page:', inCollectionHandles.length, inCollectionHandles);
console.log('⚪ [INIT] matchingHandles NOT in this collection page (missing):', matchingHandles.filter(h => !currentPageHandles.includes(h)).length);
    const missingHandles = matchingHandles.filter(h => !currentPageHandles.includes(h));
    
    console.log('Products on current page:', currentPageHandles.length);
    console.log('Matching products NOT on page:', missingHandles.length);

   if (missingHandles.length > 0) {
      const currentLimit = new URLSearchParams(window.location.search).get('limit');
      const currentPage = new URLSearchParams(window.location.search).get('page');

      // If we're on a page > 1 with vehicle params, always go back to page 1
      // Page 2+ won't have the fitment-matching products (they're on page 1 at limit=250)
      if (currentPage && currentPage !== '1') {
        console.log('⚠️ On page ' + currentPage + ' with vehicle filter — redirecting to page 1 with limit=250');
        const url = new URL(window.location.href);
        url.searchParams.set('limit', '250');
        url.searchParams.delete('page');
        window.location.replace(url.toString());
        return;
      }

      // Already on page 1 with limit=250 but still missing — filter what we have.
      if (currentLimit === '250') {
        // ⚠️ NONE of the vehicle's handles are in THIS collection. The vehicle DOES
        // fit products store-wide (matchingHandles > 0), so the earlier
        // `matchingHandles.length === 0` guard did NOT fire — but for this collection
        // there is nothing to show. Without this, filterProducts([]) just hid every
        // card and left an empty grid with no message. Show the no-products UI.
        if (inCollectionHandles.length === 0) {
          console.log('ℹ️ Vehicle fits products store-wide but NONE in this collection — showing no-products UI');
          filterProducts(inCollectionHandles); // hide all cards
          showNoProductsForVehicle();
          applyFitmentLabels(matchingHandles);
          return;
        }
        console.log('⚠️ limit=250 on page 1 but products still missing — filtering what is on page only');
        const { visibleProducts } = filterProducts(inCollectionHandles);
        const visibleFilterData = extractVisibleProductFilterData(visibleProducts);
        updateCollectionFilters(visibleFilterData);
        const positionCounts = extractFitmentPositions(visibleProducts);
        const activeFitmentPosition = sessionStorage.getItem('activeFitmentPosition');
        renderFitmentPositionWidget(positionCounts, activeFitmentPosition);
        broadcastFitmentPositions(positionCounts);
        showFilterStatus(vehicleParams, inCollectionHandles.length, fromCache);
        applyFitmentLabels(matchingHandles);
        return;
      }

      console.log('⚠️ Some matching products are not loaded. Reloading with limit=250...');
      const url = new URL(window.location.href);
      url.searchParams.set('limit', '250');
      url.searchParams.delete('page');
      window.location.replace(url.toString());
      return;
    }
// USE THIS TO PREVENT RERENDERING TO LIMIT 250 when products not found in 1st batch
    // if (missingHandles.length > 0) {
    //   console.log('⚠️ Some products still missing even at limit=250 — filtering what is on page');
    //   const { visibleCount, visibleProducts } = filterProducts(matchingHandles);
    //   const visibleFilterData = extractVisibleProductFilterData(visibleProducts);
    //   updateCollectionFilters(visibleFilterData);
    //   const positionCounts = extractFitmentPositions(visibleProducts);
    //   const activeFitmentPosition = sessionStorage.getItem('activeFitmentPosition');
    //   renderFitmentPositionWidget(positionCounts, activeFitmentPosition);
    //   broadcastFitmentPositions(positionCounts);
    //   showFilterStatus(vehicleParams, visibleCount, fromCache);
    //   return;
    // }

    // All matching products are on the page, just filter
    const { visibleProducts } = filterProducts(inCollectionHandles);
    const visibleFilterData = extractVisibleProductFilterData(visibleProducts);
    updateCollectionFilters(visibleFilterData);

    const positionCounts = extractFitmentPositions(visibleProducts);
    const activeFitmentPosition = sessionStorage.getItem('activeFitmentPosition');
    renderFitmentPositionWidget(positionCounts, activeFitmentPosition);
    broadcastFitmentPositions(positionCounts); //shop by fitment
    showFilterStatus(vehicleParams, inCollectionHandles.length, fromCache);
    applyFitmentLabels(matchingHandles);
     interceptPaginationLinks();
  }

// Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ADD HERE - Event listener for clearing fitment position filter
if (window.location.pathname.includes('/collections/')) {

 document.addEventListener('DOMContentLoaded', () => {
    const clearButton = document.getElementById('clear-fitment-position');
    if (clearButton) {
      clearButton.addEventListener('click', clearFitmentPositionFilter);
    }
    injectVehicleParamsIntoFiltersForm();
    interceptPaginationLinks();
  });

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    const widget = document.getElementById('fitment-position-widget');
    if (widget && widget.style.display === 'none') {
      const productCards = document.querySelectorAll('[data-product-handle]');
      const visibleProducts = Array.from(productCards).filter(card => {
        const gridWrapper = card.closest('.product-card-outer');
        return gridWrapper && gridWrapper.style.display !== 'none';
      });

      if (visibleProducts.length > 0) {
        const positionCounts = extractFitmentPositions(visibleProducts);
        const activeFitmentPosition = sessionStorage.getItem('activeFitmentPosition');
        renderFitmentPositionWidget(positionCounts, activeFitmentPosition);
      }
    }
    if (!hasVehicleParams(getUrlParams()) && getUrlParams()['show-all'] !== '1') {
    const allHandlesRaw = localStorage.getItem('vehicle_fitment_all_handles');
    const allHandlesParsed = allHandlesRaw ? JSON.parse(allHandlesRaw) : null;
    const resolvedHandles = (allHandlesParsed && Array.isArray(allHandlesParsed.handles)) 
      ? allHandlesParsed.handles 
      : null;
    applyFitmentLabels(resolvedHandles);
}
  }, 500);
});

}


function getCachedMatchingHandlesForCurrentCollection() {
  // Try to find any valid cache entry for the current collection + saved vehicle
  // The cache key is built from collection handle + vehicle params.
  // We scan all localStorage keys with our prefix to find a match for this collection.
  try {
    const collectionHandle = getCollectionHandle();
    if (!collectionHandle) return null;

    const keys = Object.keys(localStorage);
    for (const key of keys) {
      if (!key.startsWith(CACHE_KEY_PREFIX)) continue;
      try {
        const raw = localStorage.getItem(key);
        if (!raw) continue;
        const cacheData = JSON.parse(raw);
        const age = Date.now() - cacheData.timestamp;
        if (age > CACHE_DURATION) continue; // expired
        // Check this cache entry is for the current collection
        const keyData = JSON.parse(key.slice(CACHE_KEY_PREFIX.length));
        if (keyData.collection !== collectionHandle) continue;
        // Valid cache entry for this collection — return the handles
        if (cacheData.data && cacheData.data.product_handles) {
          return cacheData.data.product_handles;
        }
      } catch (e) {
        continue;
      }
    }
  } catch (e) {
    console.warn('Error scanning fitment cache:', e);
  }
  return null;
}

function applyFitmentLabels(matchingHandles) {
  const fitmentActive = localStorage.getItem('vehicle_fitment_active');
  const cards = document.querySelectorAll('[data-fitment-label]');

  // If no vehicle is saved at all — always show "Check compatibility"
  if (!fitmentActive) {
    cards.forEach(labelWrapper => setFitmentLabel(labelWrapper, 'check'));
    return;
  }

  // If matchingHandles were explicitly passed (collection page with URL params), use them.
  // Otherwise try: (1) global all-handles cache, (2) collection-scoped cache.
  let resolvedHandles = matchingHandles;

  if (resolvedHandles === null) {
    // Try the global all-handles cache first (works on any page)
    try {
 const raw = localStorage.getItem('vehicle_fitment_all_handles');
      if (raw) {
  const parsed = JSON.parse(raw);
  const age = Date.now() - (parsed.timestamp || 0);
if (age < CACHE_DURATION && Array.isArray(parsed.handles)) {
    resolvedHandles = parsed.handles;
    console.log('✓ Using vehicle_fitment_all_handles for label resolution, handles:', parsed.handles.length);
  }  else {
    localStorage.removeItem('vehicle_fitment_all_handles');
  }
}
    } catch(e) {}

    // Fall back to collection-scoped cache (collection pages only)
   if (resolvedHandles === null || resolvedHandles === undefined) {
  resolvedHandles = getCachedMatchingHandlesForCurrentCollection();
}
  }

  // Still nothing — show "Check compatibility"
  if (resolvedHandles === null || resolvedHandles === undefined) {
    cards.forEach(labelWrapper => setFitmentLabel(labelWrapper, 'check'));
    return;
  }

  // Vehicle is saved, handles resolved but empty — nothing fits this vehicle
  if (resolvedHandles.length === 0) {
    cards.forEach(labelWrapper => setFitmentLabel(labelWrapper, 'no-fit'));
    return;
  }
  
  cards.forEach(labelWrapper => {
    const productCard = labelWrapper.closest('[data-product-handle]');
    const productHandle = productCard?.getAttribute('data-product-handle');
    if (!productHandle) return;

    const isUniversal = productCard?.getAttribute('data-is-universal') === 'true';

    if (isUniversal || resolvedHandles.includes(productHandle)) {
      setFitmentLabel(labelWrapper, 'fits');
    } else {
      setFitmentLabel(labelWrapper, 'no-fit');
    }
  });
}

function setFitmentLabel(wrapper, state) {
  // Read car SVGs rendered by Liquid — cache after first lookup
if (!setFitmentLabel._icons || !setFitmentLabel._icons.fits) {
  const icons = {
    fits:     document.getElementById('fitment-icon-fits')?.innerHTML     || '',
    'no-fit': document.getElementById('fitment-icon-no-fit')?.innerHTML   || '',
    check:    document.getElementById('fitment-icon-check')?.innerHTML    || ''
  };
  // Only cache if we actually got the icons
  if (icons.fits || icons['no-fit'] || icons.check) {
    setFitmentLabel._icons = icons;
  } else {
    setFitmentLabel._icons = null; // force retry next call
  }
}

  const configs = {
    fits: {
      cls:  'fitment-label--fits',
      icon: setFitmentLabel._icons.fits,
      text: 'Fits your vehicle'
    },
    'no-fit': {
      cls:  'fitment-label--no-fit',
      icon: setFitmentLabel._icons['no-fit'],
      text: 'Not Compatible'
    },
    check: {
      cls:  'fitment-label--check',
      icon: setFitmentLabel._icons.check,
      text: 'Check compatibility'
    }
  };

  const config = configs[state];
  if (!config) return;

  const span = wrapper.querySelector('.fitment-label');
  if (!span) return;

  span.classList.remove('fitment-label--fits', 'fitment-label--no-fit', 'fitment-label--check', 'fitment-label--loading');
  span.classList.add(config.cls);
  span.innerHTML = config.icon + '<span style="margin-left:6px;">' + config.text + '</span>';
}

// (function patchLocalStorageForFitmentLabels() {
//   const _removeItem = localStorage.removeItem.bind(localStorage);
//   localStorage.removeItem = function(key) {
//     _removeItem(key);
//     if (key === 'vehicle_fitment_active') {
//       _removeItem('vehicle_fitment_all_handles'); // clear global handles too
//       applyFitmentLabels(null);
//     }
//   };
// })();

// // Also handle the case where another tab clears the vehicle
window.addEventListener('storage', function(e) {
  if (e.key === 'vehicle_fitment_active' && (e.newValue === null || e.newValue === '')) {
    applyFitmentLabels(null);
  }
});

})(); 


document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a.sr-applied-filter-remove');
    if (!link) return;
    // Skip "Clear All" links — let them navigate normally
    if (link.hasAttribute('sr-applied-filter-cross-all')) return;

    const href = link.getAttribute('href');
    if (!href) return;

    e.preventDefault();

    const targetUrl = new URL(href, window.location.origin);
    const currentParams = new URLSearchParams(window.location.search);

    // Params we always want to carry forward if present
    const paramsToPreserve = ['show-all', 'make', 'model', 'engine', 'year', 'limit'];
    paramsToPreserve.forEach(function (key) {
      const val = currentParams.get(key);
      if (val !== null) {
        targetUrl.searchParams.set(key, val);
      }
    });

    window.location.href = targetUrl.toString();
  });
});


// (function resolveAllFitmentLabels() {
//   function getIcons() {
//     return {
//       fits:  document.getElementById('fitment-icon-fits')  ? document.getElementById('fitment-icon-fits').innerHTML  : '&#10003;',
//       noFit: document.getElementById('fitment-icon-no-fit') ? document.getElementById('fitment-icon-no-fit').innerHTML : '&#10007;',
//       check: document.getElementById('fitment-icon-check') ? document.getElementById('fitment-icon-check').innerHTML  : '?'
//     };
//   }

//   function doResolve() {
//     var cards = document.querySelectorAll('[data-fitment-label]');
//     if (!cards.length) return;

//     var fitmentActive = localStorage.getItem('vehicle_fitment_active');
//     var resolvedHandles = null;

//     if (fitmentActive) {
//       try {
//         var raw = localStorage.getItem('vehicle_fitment_all_handles');
//         if (raw) {
//           var parsed = JSON.parse(raw);
//           if (Array.isArray(parsed.handles) && parsed.handles.length > 0) {
//             resolvedHandles = parsed.handles;
//           }
//         }
//       } catch(e) {}
//     }

//     var icons = getIcons();

//     cards.forEach(function(wrapper) {
//       var span = wrapper.querySelector('.fitment-label');
//       if (!span) return;
//       var handle = wrapper.getAttribute('data-product-handle');
//       if (!handle) {
//         var parent = wrapper.closest('[data-product-handle]');
//         handle = parent ? parent.getAttribute('data-product-handle') : null;
//       }
//       if (!handle) return;

//       var isUniversal = (wrapper.getAttribute('data-is-universal') === 'true') ||
//         (wrapper.closest('[data-is-universal]') && wrapper.closest('[data-is-universal]').getAttribute('data-is-universal') === 'true');

//       span.classList.remove('fitment-label--loading', 'fitment-label--fits', 'fitment-label--no-fit', 'fitment-label--check');

//       if (!fitmentActive || !resolvedHandles) {
//         span.classList.add('fitment-label--check');
//         span.innerHTML = icons.check + '<span style="margin-left:6px;">Check compatibility</span>';
//       } else if (isUniversal || resolvedHandles.indexOf(handle) !== -1) {
//         span.classList.add('fitment-label--fits');
//         span.innerHTML = icons.fits + '<span style="margin-left:6px;">Fits your vehicle</span>';
//       } else {
//         span.classList.add('fitment-label--no-fit');
//         span.innerHTML = icons.noFit + '<span style="margin-left:6px;">Not Compatible</span>';
//       }
//     });
//   }

//   // Expose globally so other scripts can trigger a re-resolve
//   window.doResolveFitmentLabels = doResolve;

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', doResolve);
//   } else {
//     doResolve();
//   }

//   setTimeout(doResolve, 300);
//   setTimeout(doResolve, 1000);
//   setTimeout(doResolve, 2500);
// })();



